import { getCodeSetLabelLookup } from '../../Functions/CodeSetFns'
import { formatValueDateTime } from '../../Functions/FormatValues'
import { useGetSampleRunsForHolding } from '../../APIs/Hooks/SampleRunHooks'
import { useUserContext } from '../../Contexts/UserConfig'
import { useMemo } from 'react'
import { tsMenuItem } from '../../Typescript/UI_Interfaces'

export function useSampleRunItems() {
  const sampleRunQuery = useGetSampleRunsForHolding()
  const { loginConfig } = useUserContext()

  return useMemo(() => {
    return (sampleRunQuery.data?.pendingSampleRuns ?? []).map((run) => {
      return {
        primaryText: run.SampleRunID,
        path: `/stuart/sample/run/${run.SampleRunID}`,
        secondaryText:
          getCodeSetLabelLookup(loginConfig, ['SampleRunTypeID'], run.RunType) +
          '\n' +
          formatValueDateTime(run.RunDate),
        status: 'pending',
      } as tsMenuItem
    })
  }, [sampleRunQuery.data?.pendingSampleRuns, loginConfig])
}
